import { useCachedFlag, type CachedFlag } from '../providers/CachedFlagsProvider'

export default function useNewMergeFlag(): CachedFlag<'newMerge'> {
  return useCachedFlag('newMerge')
}
